import styles from './ExpertCardConsultations.module.scss';

type ExpertCardConsultationsProps = {
  consultations: number;
};

export const ExpertCardConsultations = ({ consultations }: ExpertCardConsultationsProps) => {
  return (
    <>
      <meta itemProp="value" content={`${consultations} consultations done`} />

      <span className={styles.title}>{consultations}</span>

      <span className={styles.text}>consultations</span>
    </>
  );
};

export default ExpertCardConsultations;
